import { Button, Grid, TextField, RadioGroup, FormControlLabel, Typography, Radio } from '@mui/material';
import React from 'react';
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const SearchFilter = (props) => {
  return (
    <>
      <Grid container spacing={2} alignItems="center">
        {/* Left Section (Search & Category) */}
        <Grid item lg={6} xl={6} md={12} xs={12}>
          <Grid container spacing={2} alignItems="center">
            <Grid item md={6} xs={12}>
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Search
            </Typography>
              <TextField
                id="outlined-basic"
                name="search"
                value={props.filter?.search || ''}
                // label="Search"
                variant="outlined"
                fullWidth
                size="small"
                onChange={props.handleChange}
                disabled={!props.filter?.category}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl fullWidth size="small">
                {/* <InputLabel id="category-label">Category</InputLabel> */}
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Category
            </Typography>
                <Select
                  labelId="category-label"
                  id="demo-simple-select"
                  name="category"
                  value={props.filter?.category || ''}
                  // label="Category"
                  onChange={props.handleChange}
                >
                  <MenuItem value="ds_code">DS Code</MenuItem>
                  <MenuItem value="ds_name">DS Name</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Section (User Type & Clear Button) */}
        <Grid item lg={6} xl={6} md={12} xs={12}>
          <Grid container spacing={2} alignItems="center">
            <Grid item md={6} xs={12}>
              <FormControl fullWidth size="small">
                {/* <FormLabel>User Type</FormLabel> */}
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              User Type
            </Typography>
                <RadioGroup row name="user_type" value={props.filter?.user_type || ''} onChange={props.handleChange}>
                  <FormControlLabel value="DS" control={<Radio size='small'/>} label="DS" />
                  <FormControlLabel value="MDS" control={<Radio size='small'/>} label="MDS" />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item lg={3} xl={3} md={6} xs={12}>
              <Button fullWidth variant="contained" sx={{
                  backgroundColor: '#592375',
                  color: '#FFFFFF',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#592375'
                  }
                }} color="secondary" onClick={props.handleClear}>
                Clear
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default SearchFilter;
